import React, { useCallback, useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import BackButton from 'components/BackButton';
import InvoiceFilterBar, {
  InvoiceFilterKey,
  InvoiceReportTotal,
} from 'components/invoices/InvoiceFilterBar';
import InvoicesTable, { InvoicesTableSearchFilters } from 'components/invoices/InvoicesTable';
import usePendingPayments from 'hooks/reports/payments/usePendingPayments';
import { useNavigate } from 'react-router-dom';
import { Invoice } from 'types';

// Status is hidden: the report hard-filters PENDING.
const FILTERS: InvoiceFilterKey[] = ['productType', 'billingSources', 'paymentMethods'];

const PendingPayments = (): JSX.Element => {
  const navigate = useNavigate();

  const initialSearchFiltersValue: InvoicesTableSearchFilters = {
    productType: '',
    billingSources: [],
    status: ['PENDING'] as Array<Invoice['status']>,
    paymentMethods: [],
  };

  const [searchFilters, setSearchFilters] = useState<InvoicesTableSearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<InvoicesTableSearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState('dueDate');

  const total = usePendingPayments({ ...searchFilters });

  const handleBackClick = useCallback((): void => {
    navigate(-1);
  }, [navigate]);

  return (
    <>
      <InvoiceFilterBar
        source='pending-payments'
        title='Pending'
        filters={FILTERS}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
        csvReportType='pending-payments'
        leftSection={<BackButton handleOnClick={handleBackClick} />}
        titleDataCy='totalPendingValue'
        titleSuffix={<InvoiceReportTotal query={total} color='gray' />}
      />

      <InvoicesTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default PendingPayments;
